import React from 'react';
import { Typography } from '@material-ui/core';

function OxygenMetricReport() {
  return (
    <div>
      <Typography variant="h5">
        Oxygen Metric Report page is coming soon.
      </Typography>
    </div>
  );
}

export default OxygenMetricReport;
